<form #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Cadastros
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso nos cadastros do sistema</small>
        </div>

        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeSalvarCnpjCpfInvalido" name="podeSalvarCnpjCpfInvalido" id="podeSalvarCnpjCpfInvalido">
                    <label class="custom-control-label" for="podeSalvarCnpjCpfInvalido">Salvar CNPJ/CPF inválido</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário salvar cadastros de clientes, representantes e transportadoras mesmo com o CNPJ/CPF inválido</p>
            </li>
        </ul>
    </div>
</form>
